import {walletConnect, coinbaseWallet, injected, metaMask, safe} from 'wagmi/connectors';
import type {CreateConnectorFn} from '@wagmi/core';
import {mainnet, sepolia, bsc} from 'wagmi/chains';
import {authConnector} from '@web3modal/wagmi';
import {http, createConfig, cookieStorage, createStorage} from 'wagmi';
import {env} from 'next-runtime-env';

import {type MetaMaskParameters} from '@wagmi/connectors';

const NEXT_PUBLIC_FRONTEND_HOST_URL = env('NEXT_PUBLIC_FRONTEND_HOST_URL'),
  NEXT_PUBLIC_WALLET_CONNECT_PROJECT_ID = env('NEXT_PUBLIC_WALLET_CONNECT_PROJECT_ID'),
  NEXT_PUBLIC_RUNTIME_ENV = env('NEXT_PUBLIC_RUNTIME_ENV');

const isProduction = NEXT_PUBLIC_RUNTIME_ENV === 'production';

// 1. Get projectId from https://cloud.walletconnect.com
const projectId = NEXT_PUBLIC_WALLET_CONNECT_PROJECT_ID;

// 2. Create wagmiConfig
const metadata = {
  name: 'Win4Poker',
  description: 'Win4Poker',
  url: NEXT_PUBLIC_FRONTEND_HOST_URL, // origin must match your domain & subdomain
  icons: ['https://win4.poker/images-mobile/header-mobile/win4poker-small.webp'],
};

const walletConnectStorage =
  typeof window !== 'undefined' && window.localStorage ? window.localStorage : cookieStorage;

// create the connectors
const connectors: CreateConnectorFn[] = [];
connectors.push(walletConnect({projectId, metadata, showQrModal: true}));

// const metaMaskParameters: MetaMaskParameters = {
//   dappMetadata: {
//     name: 'Web3 Poker',
//     url: NEXT_PUBLIC_FRONTEND_HOST_URL,
//   },
//   infuraAPIKey: process.env.INFURA_API_KEY,
// };
// connectors.push(metaMask(metaMaskParameters));
// connectors.push(safe());

connectors.push(injected({shimDisconnect: true}));
// connectors.push(
//   coinbaseWallet({
//     appName: metadata.name,
//     appLogoUrl: metadata.icons[0],
//   })
// );

// connectors.push(
//   authConnector({
//     options: {projectId},
//     showWallets: true,
//     email: false,
//     walletFeatures: false,
//   })
// );

const stagingConfig = createConfig({
  chains: [mainnet, sepolia, bsc] as const,
  transports: {
    [sepolia.id]: http('https://ethereum-sepolia-rpc.publicnode.com'),
    [mainnet.id]: http('https://ethereum-rpc.publicnode.com'),
    [bsc.id]: http('https://bsc-rpc.publicnode.com'), // Add BSC transport
  },
  connectors,

  storage: createStorage({
    storage: walletConnectStorage,
  }),
});

const prodConfig = createConfig({
  chains: [mainnet, bsc] as const,
  transports: {
    [mainnet.id]: http('https://ethereum-rpc.publicnode.com'),
    [bsc.id]: http('https://bsc-rpc.publicnode.com'), // Add BSC transport
  },
  connectors,
  storage: createStorage({
    storage: walletConnectStorage,
  }),
});

const config = isProduction ? prodConfig : stagingConfig;

export default config;
